/**
 * Z-Index scale for superbar-ui components
 *
 * These values ensure proper layering within the chat widget
 * and prevent conflicts with host page elements.
 */
export const CADDIE_Z_INDEX = {
  /**
   * Base layer for chat widget
   */
  BASE: 1000,

  /**
   * Chat widget container (fixed position)
   */
  WIDGET: 99999,

  /**
   * Dropdowns and tooltips within the widget
   */
  DROPDOWN: 9998,

  /**
   * Menu overlays - must be above everything else in the widget
   */
  MENU: 100001,
} as const;

/**
 * Type for z-index values
 */
export type CaddieZIndex = (typeof CADDIE_Z_INDEX)[keyof typeof CADDIE_Z_INDEX];
